import React from 'react';
import Header from '../../components/ui/Header';
import ChatbotWidget from '../../components/ui/ChatbotWidget';
import HeroSection from './components/HeroSection';
import NavigationCards from './components/NavigationCards';
import TestimonialsSection from './components/TestimonialsSection';
import FeaturedUniversities from './components/FeaturedUniversities';
import UpcomingDeadlines from './components/UpcomingDeadlines';
import StatsSection from './components/StatsSection';

const Homepage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <main>
        {/* Hero Section */}
        <HeroSection />

        {/* Navigation Cards */}
        <NavigationCards />


        {/* Featured Universities */}
        <FeaturedUniversities />

        {/* Upcoming Deadlines */}
        <UpcomingDeadlines />

        {/* Testimonials */}
        <TestimonialsSection />

        {/* Stats Section */}
        <StatsSection />
      </main>

      {/* Chatbot Widget */}
      <ChatbotWidget />
    </div>
  );
};

export default Homepage;